// @flow

import { type UserInputValidationError } from '@tectonics/prs/validation';

const EXPIRY_DATE_REGEXP = /\d{2}\/\d{2}(\d{2})?/;

export function validateCardExpiryDate(expiryDate: string): ?UserInputValidationError {
  if (!expiryDate || expiryDate.trim() === '') {
    return { id: 'empty' };
  }

  if (!EXPIRY_DATE_REGEXP.test(expiryDate)) {
    return { id: 'invalid-pattern' };
  }

  const [expiryMonth, expiryYear] = splitExpiryDate(expiryDate);

  if (expiryMonth < 1 || expiryMonth > 12) {
    return { id: 'invalid-month' };
  }

  const [currentMonth, currentYear] = getCurrentMonthYear();

  if (expiryYear * 100 + expiryMonth < currentYear * 100 + currentMonth) {
    return { id: 'expired' };
  }

}

function splitExpiryDate(expiryDateString: string): Array<number> {
  const expiryDateParts = expiryDateString.split('/');

  const month = parseInt(expiryDateParts[0], 10);

  const year = (expiryDateParts[1].length === 2)
    ? parseInt('20' + expiryDateParts[1], 10)
    : parseInt(expiryDateParts[1], 10);

  return [month, year];
}

function getCurrentMonthYear(): Array<number> {
  const today = new Date();

  const month = today.getMonth() + 1;
  const year = today.getFullYear();

  return [month, year];
}
